//used to give a focus point for example: give a div a focus point to appear like a inputbox or textarea
$('body').on('click', 'div.focusElemet', function () {
  var opts = $(this).metadata().focusElementOpts;
  $(opts.element).focus();
});
